import React, { useEffect, useState } from 'react';
import { DatePicker } from 'rsuite';
import { edit_ud_schedule } from '../utilis/udServices';
import dayjs from 'dayjs';

const CustomDatePickerUd = ({
  id,
  field,
  row,
  rowNode,
  colDef,
  cellMode,
  hasFocus,
  tabIndex,
  formattedValue,
  isEditable,
  api,
}) => {
  // console.log(row);
  const [dt, setDt] = useState(null);
  useEffect(() => {
    if (row[field]) {
      console.log(row[field]);
      setDt(new Date(row[field]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const handleChange = async (e) => {
    // console.log(e);
    const formattedDate = dayjs(e).format('YYYY-MM-DD HH:mm:ss');
    // const date = new Date(e);
    // const dd = date.getDate();
    // const mm = date.getMonth();
    // const yyyy = date.getFullYear();
    // const hh = date.getHours();
    // const min = date.getMinutes();
    // const ss = date.getSeconds();

    // const d = `${yyyy}-${mm + 1}-${dd} ${hh}:${min}:${ss}`;
    const { batch_number } = row;
    const material_type = (() => {
      switch (row?.["Material Type"]) {
        case "SFG(without micro)":
          return "INTM";
        case "SFG(with micro)":
          return "INTM";
        case "FP(without micro)":
          return "FP";
        case "FP(with micro)":
          return "FP";
        case "CB(urgent)":
          return "CB";
        case "CB(additional)":
          return "CB";
        case "CB":
          return "CB";
        default:
          return row?.["Material Type"];
      }
    })();
    const qc_receive_date = formattedDate;
    const response = await edit_ud_schedule({ batch_number, field_to_update: "document_received_date", qc_receive_date, material_type, });
    if (response.status) {
      setDt(e);
      alert(response.message);
      api.updateRows([{ id, [field]: e }]);
    }
    else {
      alert(response.message);
    }
  };
  return (
    <div>
      <DatePicker
        format='yyyy-MM-dd HH:mm'
        calendarDefaultDate={dt}
        style={{ width: 200 }}
        value={dt}
        onChange={handleChange}
      />
    </div>
  );
};

export default CustomDatePickerUd;